import React from "react";
import { useStore } from "../../store";
import { walkthroughService } from "../../services/walkthroughService";

export const StartTourButton: React.FC = () => {
  const status = useStore((s) => s.status);

  if (status !== "idle") return null;

  return (
    <button
      onClick={() => walkthroughService.start("controls-training")}
      className="fixed bottom-6 right-6 z-50 rounded-full bg-blue-600 text-white shadow-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 px-5 py-3"
    >
      Start controls training
    </button>
  );
};

export default StartTourButton;
